import React from 'react';
import { MetaInfoDescription } from './partials/MetaInfoDescription';
import { DateFormat, DateFormats } from '../DateFormat';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type MetaInfoContent = {
  documentTypes?: string[];
  importantChangeDate?: string;
};

export function MetaInfoContent({ documentTypes, importantChangeDate }: MetaInfoContent) {
  const { t } = useSonTranslation('MetaInfo');

  return (
    <div className="meta-info__list">
      <dl className="meta-info__definition-list">
        {documentTypes && (
          <MetaInfoDescription className="invisible" term={t('documentType')}>
            {documentTypes.join(', ')}
          </MetaInfoDescription>
        )}
        {importantChangeDate && (
          <MetaInfoDescription className="invisible" term={t('creationOrChangeDate')}>
            <DateFormat date={importantChangeDate} format={DateFormats.DATE_TIME} />
          </MetaInfoDescription>
        )}
      </dl>
    </div>
  );
}
